var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktakiconelement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.38,313.3C234,278.16,181.72,268.42,152,297.54c-13.88,13.6-21.46,34-20.12,53.37,1.42,20.51,12.21,37.95,28.8,49.8,17.09,12.21,38.42,17,59,19.17,22.39,2.36,48.33,3.7,67.54-10s29-36.26,32.42-59c4.06-27.21,3.27-55.5,3-82.95-.54-61.71-6.4-124-26.15-182.79-3.23-9.6-18.49-8.46-18.27,2.47a170.73,170.73,0,0,0,8.22,49.89c4.75,14.44,11.11,29.71,22.23,40.46,9.75,9.44,22.8,14.32,36.24,11,12.92-3.23,21.84-13,23.33-26.14,1.35-11.88-17.26-11.78-18.6,0-.77,6.78-10.51,9.37-16.07,8.57-9.13-1.3-15.75-10.13-20-17.52-11.4-19.78-16.28-43.61-16.74-66.23l-18.27,2.48c15.06,44.84,22,91.66,24.37,138.8,1.17,23.11,1.34,46.27,1,69.41-.33,22.66.53,46.71-7.17,68.36-6.42,18-20,32.69-39.64,35.25-17.9,2.34-38,.44-55.55-3.72-15.78-3.74-31.86-10.55-42-23.77-9.9-12.9-11.42-29.79-6.22-44.92,5.81-16.92,20.56-29.48,38.66-30.6,18.49-1.14,36.94,7.62,46.35,23.79,6,10.35,22.1,1,16.06-9.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktakiconelement);
export default __webpack_public_path__ + "static/media/tik tak icon element.f5d9e374b5e6e0238df0309310589357.svg";
export { ForwardRef as ReactComponent };